<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <p class="lead">Nova Análise de Risco</p>
        </div>
      </div>

      <form @submit="save">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12">
            <label>Modelo de Risco</label>
            <Dropdown
              v-model="noncompliance_model_id"
              :options="noncompliance_models_dropdown"
              placeholder="Selecione um modelo"
              option-label="label"
              option-value="value"
              :filter="true"
              :show-clear="true"
            />
          </div>

          <div class="p-field p-col-12">
            <label>Não Conformidade</label>
            <Textarea v-model="form.noncompliance" rows="5" />
          </div>

          <div class="p-field p-col-12">
            <label>Tratativa</label>
            <Textarea v-model="form.treatise_alternative" rows="5" />
          </div>

          <div class="p-field p-col-12">
            <label>Natureza do Perigo</label>
            <InputText v-model="form.nature_of_risk_alternative" />
          </div>

          <div class="p-field p-col-12">
            <label>Item da Norma</label>
            <InputText v-model="form.standard_item_alternative" />
          </div>

          <div class="p-field p-col-12">
            <label>Observação Adicional</label>
            <Textarea v-model="form.additional_observations" rows="5" />
          </div>

          <div class="p-field p-col-12">
            <label>Imagens</label>
            <div class="mb-2" v-for="i in (form.pictures.length + 1)" :key="i">
              <input type="file" @change="changePicture(i - 1, $event)" />
            </div>
            <div class="form-check mt-4">
              <input
                :value="0"
                v-model="form.create_multiple_analyzes"
                class="form-check-input"
                type="checkbox"
                id="create_multiple_analyzes"
              />
              <label class="form-check-label" for="create_multiple_analyzes">
                Criar Múltiplas Análises
              </label>
            </div>
          </div>

          <div class="p-field p-col-12">
            <label>Local</label>
            <InputText v-model="form.noncompliance_placement" />
          </div>

          <div class="p-field p-col-12">
            <label>Altura</label>
            <InputNumber
              v-model="form.height"
              :min="0"
              :min-fraction-digits="2"
              :use-grouping="false"
            />
          </div>

          <div class="p-field p-col-12">
            <label>Comprimento</label>
            <InputNumber
              v-model="form.length"
              mode="decimal"
              :min="0"
              :min-fraction-digits="2"
              :use-grouping="false"
            />
          </div>

          <div class="p-field p-col-12">
            <label>Profundidade</label>
            <InputNumber
              v-model="form.depth"
              mode="decimal"
              :min="0"
              :min-fraction-digits="2"
              :use-grouping="false"
            />
          </div>

          <div class="p-field p-col-12">
            <label>Circunferência</label>
            <InputNumber
              v-model="form.circunference"
              mode="decimal"
              :min="0"
              :min-fraction-digits="2"
              :use-grouping="false"
            />
          </div>

          <div class="p-field p-col-12">
            <label>Metragem Linear</label>
            <InputNumber
              v-model="form.linear_measurement"
              mode="decimal"
              :min="0"
              :min-fraction-digits="2"
              :use-grouping="false"
            />
          </div>

          <div :style="{ display: form.according ? 'none' : 'block' }">
            <div class="p-field p-col-12">
              <div class="border p-2">
                <label>PO</label>
                <div class="radiobutton-group">
                  <div
                    class="radiobutton-wrapper"
                    v-for="(item, i) in poOptions"
                    :style="{ backgroundColor: item.color }"
                    :key="i"
                  >
                    <div class="p-field-radiobutton">
                      <RadioButton
                        name="po"
                        :value="item.value"
                        v-on:change="calculateHrnResult"
                        :id="`po-${i}`"
                        v-model="form.po"
                        :class="{ disabled: form.according }"
                        :disabled="form.according"
                      />
                      <label :for="`po-${i}`">{{ item.description }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="p-field p-col-12">
              <div class="border p-2">
                <label>GPD</label>
                <div class="radiobutton-group">
                  <div
                    class="radiobutton-wrapper"
                    v-for="(item, i) in gpdOptions"
                    :style="{ backgroundColor: item.color }"
                    :key="i"
                  >
                    <div class="p-field-radiobutton">
                      <RadioButton
                        name="gpd"
                        :value="item.value"
                        v-on:change="calculateHrnResult"
                        :id="`gpd-${i}`"
                        v-model="form.gpd"
                        :disabled="form.according"
                      />
                      <label :for="`gpd-${i}`">{{ item.description }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="p-field p-col-12">
              <div class="border p-2">
                <label>FE</label>
                <div class="radiobutton-group">
                  <div
                    class="radiobutton-wrapper"
                    v-for="(item, i) in feOptions"
                    :style="{ backgroundColor: item.color }"
                    :key="i"
                  >
                    <div class="p-field-radiobutton">
                      <RadioButton
                        name="fe"
                        :value="item.value"
                        v-on:change="calculateHrnResult"
                        :id="`fe-${i}`"
                        v-model="form.fe"
                        :disabled="form.according"
                      />
                      <label :for="`fe-${i}`">{{ item.description }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="p-field p-col-12">
              <div class="border p-2">
                <label>NP</label>
                <div class="radiobutton-group">
                  <div
                    class="radiobutton-wrapper"
                    v-for="(item, i) in npOptions"
                    :style="{ backgroundColor: item.color }"
                    :key="i"
                  >
                    <div class="p-field-radiobutton">
                      <RadioButton
                        name="np"
                        :value="item.value"
                        v-on:change="calculateHrnResult"
                        :id="`np-${i}`"
                        v-model="form.np"
                        :disabled="form.according"
                      />
                      <label :for="`np-${i}`">{{ item.description }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="p-field p-col-12">
              <div class="border p-2">
                <label>ISO 12100</label>
                <div class="radiobutton-group">
                  <div
                    class="radiobutton-wrapper"
                    v-for="(item, i) in complementar12100Options"
                    :style="{ backgroundColor: item.color }"
                    :key="i"
                  >
                    <div class="p-field-radiobutton">
                      <RadioButton
                        name="complementar12100"
                        :value="item.value"
                        :id="`complementar12100-${i}`"
                        v-model="form.complementar12100"
                        :disabled="form.according"
                      />
                      <label :for="`complementar12100-${i}`">{{
                        item.description
                      }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="p-field p-col-12">
              <div class="border p-2 d-flex flex-column">
                <label>Resultado da conta HRN</label>
                <div
                  class="hrn-result"
                  :class="{ unacceptable: getHrnLevel(hrn_result) === 8 }"
                  :style="`background-color: ${getHrnLevelColor(
                    getHrnLevel(hrn_result),
                  )}`"
                >
                  {{ formatHrnResult(hrn_result) }}
                </div>
              </div>
            </div>
          </div>

          <div class="p-field p-col-12">
            <div class="border p-2 d-flex flex-column">
              <label>Situação Conforme</label>
              <div class="form-check form-check-inline mt-3">
                <button
                  v-on:click="toggleAccordingButton($event)"
                  class="buttons mr-3"
                  v-bind:class="{ 'buttons-active': form.according }"
                >
                  <label class="form-check-label">
                    Conforme
                  </label>
                </button>
              </div>
            </div>
          </div>
        </div>

        <button class="btn btn-dark">{{ submit_text }}</button>
      </form>
    </div>
  </div>
  <Dialog
    :closable="false"
    :visible="displayModal"
    :style="{ width: '40vw' }"
    :modal="true"
    class="modal-content modal-machines"
  >
    <template #header class="modal-header">
      <h5 class="modal-title">Atribuir frente de trabalho?</h5>
    </template>

    <div class="modal-body">
      <div class="">
        Atribuir situação à frente de trabalho 
        <span class="font-weight-bold">{{ workFront.name }}</span>?
      </div>
      <div class="mt-5 small">
        Você poderá alterar a frente de trabalho no plano de ação.
      </div>
    </div>

    <template #footer>
      <button class="btn btn-danger" @click="closeModal()">Não atribuir</button>
      <button class="btn btn-primary" @click="saveWorkFront()">
        Atribuir
      </button>
    </template>
  </Dialog>
</template>

<script>
  import { useRoute } from 'vue-router'

  import InputText from 'primevue/inputtext'
  import Dropdown from 'primevue/dropdown'
  import Textarea from 'primevue/textarea'
  import InputNumber from 'primevue/inputnumber'
  import RadioButton from 'primevue/radiobutton'
  import Dialog from 'primevue/dialog'
  import useSwal from "../../modules/Swal";
  import useHrn from '@/modules/Hrn.js';
  import Swal from 'sweetalert2/src/sweetalert2.js'

  import useNoncomplianceModels from '@/modules/NoncomplianceModel.js'

  export default {
    components: {
      InputText,
      Dropdown,
      Textarea,
      InputNumber,
      RadioButton,
      Dialog,
    },
    setup() {
      const route = useRoute()
      const { machineId } = route.params
      const { showSuccessDialog, showErrorDialog, showAjaxDialog } = useSwal()
      const { getHrnLevelColor, getHrnLevel } = useHrn()

      const {
        listNoncomplianceModelsNoPagination,
        listNoncomplianceModel,
        noncompliance_models_dropdown,
        noncompliance_model_form_data,
      } = useNoncomplianceModels()

      return {
        machineId,
        noncompliance_models_dropdown,
        noncompliance_model_form_data,
        listNoncomplianceModelsNoPagination,
        listNoncomplianceModel,
        showErrorDialog,
        showSuccessDialog,
        showAjaxDialog,
        getHrnLevelColor,
        getHrnLevel,
      }
    },
    data() {
      return {
        noncompliance_model_id: null,
        form: {
          noncompliance: '',
          treatise_alternative: '',
          nature_of_risk_alternative: '',
          standard_item_alternative: '',
          additional_observations: '',
          pictures: [],
          create_multiple_analyzes: 0,
          noncompliance_placement: '',
          height: null,
          length: null,
          depth: null,
          circunference: null,
          linear_measurement: null,
          po: null,
          gpd: null,
          fe: null,
          np: null,
          complementar12100: null,
          according: 0,
        },
        poOptions: [],
        gpdOptions: [],
        feOptions: [],
        npOptions: [],
        complementar12100Options: [],
        hrn_result: 0,
        submit_text: 'Cadastrar',
        displayModal: false,
        riskAnalysisDescription: {},
        workFront: {},
      }
    },
    methods: {
      save(event) {
        event.preventDefault()

        let app = this
        let request = {
            url: `/api/machines/${this.machineId}/risk-analysis/storeOrUpdate`,
            data: new FormData(),
            config: {
                headers: {
                    'content-type': 'multipart/form-data',
                },
            },
        }

        if (this.form.according) {
          this.form.po = 0
          this.form.gpd = 0
          this.form.fe = 0
          this.form.np = 0
          this.form.complementar12100 = 0
        }

        for (let k in this.form) {
            request.data.append(k, this.form[k])
        }

        this.form.pictures.forEach(picture => {
          const blob = this.resizeImage(picture)
          const file = new File([blob], 'default.jpg', { type: blob.type })
          request.data.append('picture[]', file)
        })

        request.data.append('create_multiple_analyzes', this.form.create_multiple_analyzes ? 1 : 0)
        request.data.append('noncompliance_model_id', this.noncompliance_model_id)

        Swal.fire({
            title: 'Tem certeza desta operação?',
            text: 'Verifique todos os campos antes de efetuar o cadastro.',
            confirmButtonText: 'Cadastrar',
            cancelButtonText: 'Cancelar',
            showCancelButton: true,
            showLoaderOnConfirm: true,
            preConfirm: function () {
              let id = 0

              return app.axios
                  .post(request.url, request.data, request.config)
                  .then((data) => {
                      app.riskAnalysisDescription = data.data
                      id = data.data.id
                      app.showSuccessDialog()
                  })
                  .catch(error => {
                        let result = ''

                        if (error && error.response.data) {
                            let container = document.createElement('div')

                            let paragraph = document.createElement('p')
                            if (error.response.data.message) {
                                paragraph.appendChild(
                                    document.createTextNode(error.response.data.message),
                                )
                                paragraph.classList.add('alert')
                                paragraph.classList.add('alert-danger')
                            }

                            let list = document.createElement('ul')
                            for (let key in error.response.data.errors) {
                                let itemElement = document.createElement('li')
                                itemElement.appendChild(
                                    document.createTextNode(error.response.data.errors[key]),
                                )
                                list.appendChild(itemElement)
                            }

                            container.appendChild(paragraph)
                            container.appendChild(list)
                            result = container
                        }

                        app.showErrorDialog(result)
                  })
                  .finally(() => {
                    if (id)
                      app.getWorkFront(id)
                    else
                      setTimeout(() => {
                        window.history.go(-1)
                      }, 500)
                  })
          },
        })
      },
      async getWorkFront(rad_id) {
        await this.axios
          .get('/api/action-plan/get-work-front/' + rad_id)
          .then(({ data }) => {
            this.workFront = data
          })
          .catch((error) => {
            console.log(error)
          })

        if (this.workFront && this.workFront.id)
          this.showModal()
        else
          this.closeModal()
      },
      showModal() {
        this.displayModal = true
      },
      closeModal() {
        this.displayModal = false

        setTimeout(() => {
          window.history.go(-1)
        }, 500)
      },
      async saveWorkFront() {
        let app = this

        const rad = Object.assign({}, app.riskAnalysisDescription)
        const work_front = Object.assign({}, app.workFront)

        await app.axios
          .get(
            `/api/action-plan/save-work-front/?&rad_id=${rad.id}&work_front_id=${work_front.id}`,
          )
          .then((data) => {
              app.showSuccessDialog()
          })
          .catch(error => {
                let result = ''

                if (error && error.response.data) {
                    let container = document.createElement('div')

                    let paragraph = document.createElement('p')
                    if (error.response.data.message) {
                        paragraph.appendChild(
                            document.createTextNode(error.response.data.message),
                        )
                        paragraph.classList.add('alert')
                        paragraph.classList.add('alert-danger')
                    }

                    let list = document.createElement('ul')
                    for (let key in error.response.data.errors) {
                        let itemElement = document.createElement('li')
                        itemElement.appendChild(
                            document.createTextNode(error.response.data.errors[key]),
                        )
                        list.appendChild(itemElement)
                    }

                    container.appendChild(paragraph)
                    container.appendChild(list)
                    result = container
                }

                app.showErrorDialog(result)
          })

        this.closeModal()
      },
      resizeImage(image) {
        const MAX_WIDTH = 800
        const MAX_HEIGHT = 600

        const canvas = document.createElement('canvas')
        const context = canvas.getContext('2d')

        let width = image.width
        let height = image.height

        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width
            width = MAX_WIDTH
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height
            height = MAX_HEIGHT
          }
        }

        canvas.width = width
        canvas.height = height
        context.drawImage(image, 0, 0, width, height)
        const b64 = canvas.toDataURL('image/jpeg', 0.8)
        const blob = this.b64toBlob(b64)
        return blob
      },
      b64toBlob(dataURI) {
        const byteString = atob(dataURI.split(',')[1]);
        const arrayBuffer = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(arrayBuffer);
        
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([arrayBuffer], { type: 'image/jpeg' });
      },
      changePicture(key, event) {
        const file = event.target.files[0]
        const reader = new FileReader()

        reader.addEventListener('load', () => {
          const image = new Image()
          image.src = reader.result
          this.form.pictures[key] = image
        })

        reader.readAsDataURL(file)
      },
      toggleAccordingButton(event) {
        event.preventDefault()
        if (this.form.according) this.form.according = 0
        else this.form.according = 1
      },
      calculateHrnResult() {
        if (this.form.po && this.form.gpd && this.form.fe && this.form.np) {
          this.hrn_result = this.form.po * this.form.gpd * this.form.fe * this.form.np
        } else {
          this.hrn_result = 0
        }
      },
      formatHrnResult(hrn) {
        const hrnFormatted = parseFloat(hrn).toFixed(3)
        if (isNaN(hrnFormatted)) return ''
        return hrnFormatted
      },
    },
    watch: {
      noncompliance_model_id: async function (newValue) {
        this.listNoncomplianceModel(newValue)
      },
      noncompliance_model_form_data: function (newValue) {
        this.form.noncompliance = newValue.description
        this.form.treatise_alternative = newValue.treatise
        this.form.nature_of_risk_alternative =
          newValue.noncompliance_model_nature_of_risk.name

        this.form.standard_item_alternative = newValue.standard_items.reduce(
          (acc, item) => acc + ' ' + item.name,
          '',
        )
      },
    },
    mounted() {
      this.listNoncomplianceModelsNoPagination()

      this.axios
        .get('/api/risk-analysis-metrics/all')
        .then((response) => {
          const { po, gpd, np, fe, iso12100 } = response.data.data

          this.poOptions = po
          this.gpdOptions = gpd
          this.npOptions = np
          this.feOptions = fe
          this.complementar12100Options = iso12100
        })
        .catch((error) => {
          console.log(error)
        })
    },
  }
</script>

<style lang="scss" scoped>
  .radiobutton-wrapper {
    display: inline-flex;
    margin-right: 20px;
    margin-bottom: 10px;
    border-radius: 10px;
    padding: 5px 10px;

    .p-field-radiobutton {
      margin-bottom: 0;
    }

    label {
      margin-top: 10px;
    }
  }

  .buttons {
    padding: 10px 20px;
    font-weight: bold;
    color: white;
    background-color: rgb(145, 145, 145);
    border: black solid 1px;
    border-radius: 4px;
    transition: 0.3s;
  }

  .buttons-active {
    transition: 0.3s;
    background-color: rgb(255, 145, 0);
    border: grey solid 1px;
  }

  .hrn-result {
    padding: 5px 20px;
    width: 130px;
    text-align: center;
    border-radius: 4px;
  }

  .unacceptable {
    color: #fff;
  }

  .disabled {
    opacity: 50%;
    fill-opacity: 50%;
  }
</style>
